module.exports = __webpack_public_path__ + "img/queHacer.2ab81c73.svg";